var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapping-box-container main-content--container"},[_c('div',{staticClass:"controls",attrs:{"id":"controls"}}),_c('loading-spinner',{staticClass:"main-content--spinner"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }